/* eslint {new-cap: 'off'} */
import vI18n from 'vue-simple-i18n'

import enUS from './en-us.js'
import zhCN from './zh-cn.js'

const i18n = new vI18n({
  locales: {
    'en-us': enUS,
    'zh-cn': zhCN
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js